import axiosInstance from "./axiosInstance";

// For one-off fetch call that uses native fetch API
export const fetchTimeSlots = async (jobId) => {
  try {
    const response = await axiosInstance.get(`create_time_slots/${jobId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching time slots:", error);
    const errorMessage = error.response?.data?.message || "Failed to fetch time slots";
    throw new Error(errorMessage);
  }
};

export const fetchInterviewData = async (jobId) => {
  try {
    const response = await axiosInstance.get(`interview/${jobId}/`);
    const fetchedData = response.data["Total Scores"] || [];
    return fetchedData;
  } catch (error) {
    console.error("Error fetching interview data:", error);
    throw error;
  }
};

export const createTimeSlots = async (jobId, payload) => {
  try {
    const response = await axiosInstance.post(`create_time_slots/${jobId}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error creating time slots:", error);
    throw error;
  }
};

export const sendEmailToCandidate = async (jobId, resumeId) => {
  try {
    const response = await axiosInstance.post(`send_email/${jobId}/${resumeId}/`, {});
    return response.data;
  } catch (error) {
    console.error("Error sending email to candidate:", error);
    throw error;
  }
};

export const fetchRankings = async (jobId) => {
  try {
    const response = await axiosInstance.get(`interview/${jobId}/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching rankings:", error);
    throw error;
  }
};

export const InterviewConfig = async (payload,jobId) => {
  try {
    const response = await axiosInstance.post(`/api/interview-configs/${jobId}`,payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching interview config:", error);
    throw error;
  }
};

export const GetInterviewConfig = async (jobId) => {
  try {
    const response = await axiosInstance.get(`/api/interview-configs/${jobId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching interview config:", error);
    throw error;
  }
};

export const UpdateInterviewConfig = async (payload,jobId) => {
  try {
    const response = await axiosInstance.put(`/api/interview-configs/${jobId}`,payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching interview config:", error);
    throw error;
  }
};

export const startBatchCallAPI = async (jobId, resumeIds, windowStart, windowEnd, timezone) => {
  try {
    const response = await axiosInstance.post(`jobs/${jobId}/batch-call`, {
      resume_ids: resumeIds,
      window_start: windowStart,
      window_end: windowEnd,
      timezone: timezone,
    });
    return response.data;
  } catch (error) {
    const msg = error.response?.data?.message || "Failed to schedule batch calls";
    throw new Error(msg);
  }
};

export const getBatchStatusAPI = async (jobId) => {
  try {
    const response = await axiosInstance.get(`jobs/${jobId}/batch-call`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
